<div id="slider" appSlider [currentConfig]="currentConfig">
  	<div class="control_next">
  		<p>
			<span>
				<i class="fas fa-chevron-right"></i>
			</span>
		</p>
  	</div>
  	<div class="control_prev">
  		<p>
			<span>
				<i class="fas fa-chevron-left"></i>
			</span>
		</p>
  	</div>
  	<ul>
    	<li class="puntero" *ngFor="let newItem of lista | sort:'nombre'" [ngClass]="{'tarjeta':tipo === '3'}">
    		

    		<section *ngIf=" tipo === '1' || tipo === '2' " [ngClass]="{'tipo1':tipo === '1', 'tipo2':tipo === '2'}" (click)="fnSeleccion( newItem )">
				<img [src]=" fnGetImage( newItem ) " alt="{{ newItem.nombre }}" loading="lazy"/>
			</section>
			

			<app-tarjeta-producto *ngIf="tipo === '3' " [newProducto]="newItem"></app-tarjeta-producto>


			<div class="categorias" (click)="fnSeleccion( newItem )" *ngIf=" tipo === '4' ">
				<figure>
					<img [src]=" fnGetImage( newItem ) " [alt]="newItem.nombre"  loading="lazy"/>
				</figure>
				<figcaption>
					<p class="color-black">{{ newItem.nombre }}</p>
				</figcaption>
			</div>
			
    	</li>
  	</ul>  
</div>